import React from 'react'
import Header from '../Component/Header'
// import CoureseBreadcrumb from '../Component/CoureseBreadcrumb'
import Footer from '../Component/Footer'
import Testimonials from '../Component/Testimonials'
import Blog from '../Component/Blog'
import OurCourse from '../Component/OurCourse'
import FAQ from '../Component/FAQ'
import MainCourseBreadcrumb from '../Component/MainCourseBreadcrumb'
import FeaturedCourses from '../Component/FeaturedCourses'
import GoogleReviews from '../Component/GoogleReviews'
function MainCoursePage() {
    return (
        <div>
            <Header />
            {/* <CoureseBreadcrumb /> */}

            <MainCourseBreadcrumb />
            <OurCourse />

            <FeaturedCourses />
            <GoogleReviews />
            <FAQ />
            <Testimonials />
            <Blog />
            <Footer />
        </div>
    )
}

export default MainCoursePage